import React, { useState } from 'react'
import Logo from '../assets/logo.webp';
import { NavLink, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Header = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const navigate = useNavigate();

    // Function to close the dropdown when a link is clicked
    const closeDropdown = (e) => {
        // Prevent the dropdown from staying open
        const dropdown = e.target.closest('.dropdown-toggle');
        if (dropdown) {
            const dropdownMenu = dropdown.nextElementSibling;
            dropdownMenu.classList.remove('show');
        }
        // Close the sidebar if open
        setShowSidebar(false);
    }

    return (
        <>
            <header className='py-2 sticky-top bg-white'>
                <div className='container d-flex justify-content-between'>
                    <img src={Logo} className='header-logo' alt='Logo' />
                    <div className='d-lg-flex d-md-flex d-none'>
                        <NavLink className='nav-text' activeClassName='active' to='/' >Home</NavLink>
                        <NavLink className='nav-text' activeClassName='active' to='/about' >About</NavLink>
                        <NavLink className='nav-text' activeClassName='active' to='/services' >Services</NavLink>
                        
                        <NavLink
                            className='nav-text dropdown-toggle'
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            activeClassName='active'
                            to='/product'
                            onClick={closeDropdown}
                        >
                            Products
                            <ul className="dropdown-menu border-0" aria-labelledby="navbarDropdown">
                                <li className='my-1 px-3' onClick={() => { navigate('/billing-software'); window.location.reload(); }}>Billing Software</li>
                                <li className='my-1 px-3' onClick={() => { navigate('/hotel-management'); window.location.reload(); }}>Hotel Management</li>
                                <li className='my-1 px-3' onClick={() => { navigate('/mlm-software'); window.location.reload(); }}>MLM Software</li>
                                <li className='my-1 px-3' onClick={() => { navigate('face-attendance'); window.location.reload(); }}>Face Attendance</li>
                            </ul>
                        </NavLink>

                        <NavLink className='nav-text' activeClassName='active' to='/partners' >Partners</NavLink>

                        <NavLink className='nav-text' activeClassName='active' to='/careers' >Careers</NavLink>
                        <NavLink className='nav-text' activeClassName='active' to='/contact' >Contact</NavLink>
                    </div>

                    <button className='header-btn my-2 d-lg-block d-none'><Link className='text-light text-decoration-none' to='tel:8707510135'>Call Us: 870 751 0135</Link></button>

<div className='d-flex'>
            <button className='header-btn my-2 d-md-none d-block bg-success' onClick={() => window.open('https://wa.me/918707510135?text=Hey!%20Dectwin%20Services.%20I%20have%20an%20enquiry.', '_blank')}><i class="fa-brands fa-whatsapp"></i></button>
            <button className='header-btn m-2 d-md-none d-block bg-danger' onClick={() => window.open('tel:8707510135')}><i class="fa-solid fa-headset"></i></button>
                    <button className='header-btn my-2 d-md-none d-block' onClick={() => setShowSidebar(true)}><i className="fa-solid fa-bars-staggered"></i></button></div>
                </div>
            </header>

            {showSidebar && (
                <section className='sidebar-area'>
                    <div className='sidebar-area-inner animate__animated animate__fadeInLeft'>
                        <button className='header-btn d-md-none d-block float-end' onClick={() => setShowSidebar(false)}><i className="fa-solid fa-xmark"></i></button>
                        <div className='mt-4'>
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/' >Home</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/about' >About</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/services' >Services</NavLink><br />
                            <hr className='mx-2' /><p className='banner-subheading mx-2'>Products</p>
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/billing-software' >Billing Software</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/hotel-management' >Hotel Management</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/mlm-software' >MLM Software</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/face-attendance' >Face Attendance</NavLink><br />
                            <hr className='mx-2' />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/partners' >Partners</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/careers' >Careers</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/contact' >Contact</NavLink><br /><br />
                            <NavLink className='nav-text mx-0' onClick={() => setShowSidebar(false)} activeClassName='active' to='/support' >Support</NavLink>
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}

export default Header;
